
import React, { useState, useEffect } from "react";
import { Dropdown, Modal } from "react-bootstrap";
import 'react-toastify/dist/ReactToastify.css';
import { useAddProject } from "../../../hooks/Refund/useAddProject_Refund";

function AddProject({ isEditMode = false, editData = null, onEditComplete = () => { }, data }) {
    const {
        showAddModal,
        showSuccessModal,
        formData,
        isDropdownOpen,
        isProcessing,
        filteredProjects,
        handleOpenAddModal,
        handleCloseAddModal,
        handleOpenSuccessModal,
        handleCloseSuccessModal,
        toggleDropdown,
        handleProjectSelect,
        handleInputChange,
        handleSubmit
    } = useAddProject({ isEditMode, editData, onEditComplete, data });

    return (
        <>
            {!isEditMode && (
                <button isabled={filteredProjects?.length === 0} onClick={handleOpenAddModal} className="projectbtn">
                    Add Project
                </button>
            )}

            <Modal
                show={showAddModal}
                onHide={handleCloseAddModal}
                className="creditmodal newcreditmodal"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>{isEditMode ? 'Edit Refund Project' : 'Add a Project'}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Dropdown show={isDropdownOpen} onToggle={toggleDropdown}>
                        <Dropdown.Toggle
                            variant="success"
                            id="dropdown-basic"
                            style={{
                                borderColor: isDropdownOpen ? "#329879" : "transparent",
                            }}
                            onClick={toggleDropdown}
                            disabled={isEditMode}
                        >
                            {!formData.selectedProject ? (
                                <>Select Project</>
                            ) : (
                                <div className="tokeninner">
                                    <div className="tokenimg">
                                        <img
                                            src={formData.selectedProject.imageSrc}
                                            alt={formData.selectedProject.label}
                                            className="innerimg"
                                        />
                                    </div>
                                    <p className="tokenpara">{formData.selectedProject.label}</p>
                                </div>
                            )}
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="15"
                                height="8"
                                viewBox="0 0 15 8"
                                fill="none"
                                style={{
                                    rotate: isDropdownOpen ? "180deg" : "0deg",
                                    transition: "rotate 0.3s ease-in-out",
                                }}
                            >
                                <path
                                    d="M0.535156 0.5L0.535157 3.47056L7.76848 7.5L7.76848 4.52943L0.535156 0.5Z"
                                    fill="black"
                                />
                                <path
                                    d="M15 0.500122L15 3.47068L7.76667 7.50012L7.76667 4.52955L15 0.500122Z"
                                    fill="black"
                                />
                            </svg>
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <div className="tokenmain">
                                {filteredProjects?.map((project, index) => (
                                    <div
                                        key={index}
                                        className="tokeninner"
                                        onClick={() => handleProjectSelect(project)}
                                        style={{ cursor: "pointer" }}
                                    >
                                        <div className="tokenimg">
                                            <img
                                                src={project.imageSrc}
                                                alt={project.label}
                                                className="innerimg"
                                            />
                                        </div>
                                        <p className="tokenpara">{project.label}</p>
                                    </div>
                                ))}
                            </div>
                        </Dropdown.Menu>
                    </Dropdown>
                    <input
                        type="text"
                        placeholder="Refund Limit"
                        className="modalinput"
                        name="refundLimit"
                        value={formData.refundLimit}
                        onChange={handleInputChange}
                    />
                    <input
                        type="text"
                        placeholder="Refund Limit Per User"
                        className="modalinput"
                        name="refundLimitPerUser"
                        value={formData.refundLimitPerUser}
                        onChange={handleInputChange}
                    />
                    <div className="bottombtns">
                        <button className="dullbtn" onClick={handleCloseAddModal}>Cancel</button>
                        <button
                            onClick={handleSubmit}
                            className="greenbtn"
                            disabled={isProcessing}
                        >
                            {isProcessing ? 'Loading...' : (isEditMode ? 'Update' : 'Add')}
                        </button>
                    </div>
                </Modal.Body>
            </Modal>
            <Modal show={showSuccessModal} onHide={()=>handleCloseSuccessModal()} className="creditmodal newcreditmodal" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Success</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="80"
                        height="81"
                        viewBox="0 0 80 81"
                        fill="none"
                        className="tickimg"
                    >
                        <path
                            d="M40 78.3947C60.9286 78.3947 77.8947 61.4286 77.8947 40.5C77.8947 19.5713 60.9286 2.60522 40 2.60522C19.0713 2.60522 2.10522 19.5713 2.10522 40.5C2.10522 61.4286 19.0713 78.3947 40 78.3947Z"
                            fill="#329879"
                        />
                        <path
                            d="M36.1262 54.8997C35.5788 54.8997 35.0315 54.6892 34.6525 54.2681L22.9473 42.5629C22.1051 41.7208 22.1051 40.4155 22.9473 39.5734C23.7894 38.7313 25.0946 38.7313 25.9367 39.5734L35.9999 49.6366L54.0209 26.8997C54.7367 25.9734 56.0841 25.8471 56.9683 26.5629C57.8946 27.2787 58.0209 28.626 57.3051 29.5102L37.8104 54.0997C37.4315 54.5629 36.8841 54.8576 36.2946 54.8997C36.2104 54.8997 36.1683 54.8997 36.1262 54.8997Z"
                            fill="#E2E9EC"
                        />
                    </svg>
                    <h6 className="successhead">Project successfully {isEditMode ? 'updated' : 'added'}</h6>
                    <button onClick={handleCloseSuccessModal} className="closebtn">
                        Close
                    </button>
                </Modal.Body>
            </Modal>
        </>
    );
}

export default AddProject;